import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import Support from './pages/Support';
import Privacy from './pages/Privacy';
import Home from './pages/Home';

function App() {
  return (
    <Router basename="/swiftbreak">
      <div className="App">
        <nav className="navbar">
          <div className="nav-container">
            <Link to="/" className="nav-logo">
              🎱 SwiftBreak
            </Link>
            <ul className="nav-menu">
              <li className="nav-item">
                <Link to="/" className="nav-link">Home</Link>
              </li>
              <li className="nav-item">
                <Link to="/support" className="nav-link">Support</Link>
              </li>
              <li className="nav-item">
                <Link to="/privacy" className="nav-link">Privacy</Link>
              </li>
            </ul>
          </div>
        </nav>

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/support" element={<Support />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>

        <footer className="footer">
          <div className="footer-container">
            <p>@2026 李光浩. All rights reserved.</p>
            <div className="footer-links">
              <Link to="/support">Support</Link>
              <span className="separator">|</span>
              <Link to="/privacy">Privacy Policy</Link>
            </div>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
